/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from 'api';
import BreadcrumcomponentLogo from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import {
  ambienteAplicacion,
  urlActualizarCotitzacionAP,
  urlCatalogosCotizador,
  urlResumenCotizadorMex,
} from 'constants/urls';
import { useNavbarContext } from 'contexts/NavbarContext';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Loading from 'wrappers/Loading';
import { MarineInland } from './constantes/general';
import DatosPersonales from './formas/datosPersonales';
import './styles.scss';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import withValidarRecuperar from 'HOC/withValidarRecuperar'

const MarineInlandDatosLead = ({
  history,
  addWarningToast,
  params: { idCotizacion },
  dataUsuario,
  estadoGeneral
}) => {
  const [loading, setLoading] = useState(false);

  const { cliCodigoCore, userIsLoggedIn, correo } = dataUsuario;
  const [catalogo, setCatalogo] = useState({});

  useNavbarContext(MarineInland.codProducto);

  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit, reset } = methods;

  const solicitarCatalogosGeneral = async () => {
    setLoading(true);
    const solicitudCatalogos = {
      datosCotizador: {
        prodCodigo: MarineInland.codProducto,
        ambiente: ambienteAplicacion,
        pasoCodigo: 'catalogosLead',
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
        }
      }            
    };    
    let resp = await consumirServicioEncirptacion(urlCatalogosCotizador, solicitudCatalogos);   
     //console.log("CATALOGO",resp) 
    setCatalogo(resp?.catalogo?.catalogos);         
    if(idCotizacion){
      await getData()
    }
    setLoading(false);
    return true  
  };

  const getData = async () => {   
    setLoading(true);        
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
    };     
    let resp = await consumirServicioEncirptacion(urlResumenCotizadorMex, DataResumen);    
    if(resp?.transaccion){
      if(resp?.cotConsulta?.carContratante?.itemsGenerales){
        const datos = resp?.cotConsulta?.carContratante?.itemsGenerales;                          
        reset({
          ...
          datos
        }) 
      } 
    }
    else{
      addWarningToast('No se ha podido cargar la información de la cotización');
    }  
    setLoading(false);      
  };

  useEffect(() =>{ 
    solicitarCatalogosGeneral()          
  }, [idCotizacion]);

  const onSubmit = async (data) => { 
    if(estadoGeneral?.polizaPagada?.validacion){
      onRedireccionar(idCotizacion) 
    }   
    else{
      setLoading(true);
      const Data = {
        ambiente: ambienteAplicacion,
        prodCodigo: MarineInland.codProducto,    
        pasoCodigo: 'crearLead',
        items: {
          cotCodigo: idCotizacion || '',
          datosCliente: data.datosCliente,
          datosGenerales: data.datosGenerales,
          usuCotiza: { usuCodigo: cliCodigoCore || '' },
          agente: data.agente,
        },
      };
      // console.log('DtMarine',JSON.stringify(Data))
      const res = await consumirServicioEncirptacion(urlActualizarCotitzacionAP, Data);    
  
      if (res?.transaccion === true && res?.id) {
        if (res?.warnings?.forEach) {
          res.warnings.forEach((warning) => {
            addWarningToast(warning, { autoDismiss: false });
          });
        }           
        // let recuperar=''
        // if(idCotizacion){ recuperar='?back=true'}
        // history.replace(`${MarineInland.urls.datosLead}/${res?.id}`);
        // history.push(`${MarineInland.urls.ingresoEquipos}/${res?.id}${recuperar}`); 
        onRedireccionar(res?.id);     
      } else {
        reset(data);
        try {
          res.errorDescripcion.forEach((msg) =>
            addWarningToast(msg, { autoDismiss: false }),
          );
        } catch (e) {
          addWarningToast(res?.errorDescripcion || 'Error desconocido', {
            autoDismiss: false,
          });
        }
      }
      setLoading(false);
    }
    
  };
  const onRedireccionar = (id) => {
    let recuperar=''
      if(idCotizacion){ recuperar='?back=true'}
      history.replace(`${MarineInland.urls.datosLead}/${id}`);
      history.push(`${MarineInland.urls.ingresoEquipos}/${id}${recuperar}`);  
  };
  
  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <BreadcrumcomponentLogo
            {...PASOS_BREADCRUMBS[MarineInland.codProducto].breadCrumb}            
          />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS
              [MarineInland.codProducto].breadCrumbPasos[1]}            
          />      
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>              
              <DatosPersonales
                disclaimer={catalogo?.disclaimer}
                catalogo={catalogo}
                inputs={[
                  'usuNombre',
                  'usuTelefono',
                  'usuCorreo',
                  'usuRFC',
                  'usuCodPostal',
                  'usuEstado',
                  'usuMunicipio',
                  'usuColonia',
                  'usuTipoContratante',
                  'disclaimerTerminos',
                ]}
                clavesAgente={catalogo?.permisos?.agentes}                
              />              
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(MarineInlandDatosLead,MarineInland.codProducto);
